import DynamicPageSection from "./DynamicPageSection"

export default DynamicPageSection
